export default __webpack_public_path__ + "static/media/preview.16f071be.mp4";